import React from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import Header from './DataComponent__TableHeader';
import Loading from '../Loading';

const DataComponentTablePaymentAccounts = ({
    data: propData,
    loading: propLoading,
    headerNames: propHeaderNames,
    multiLevelHeaderNames: propMultiLevelHeaderNames,
    columnData: propColumnData,
    className: propClassName,
    t
}) => {
    const staticNames = t?.dataTable || {};

    const getKey = (data) => {
        if (React.isValidElement(data)) {
            return getKey(data.props.children);
        }

        return data;
    };

    return (
        <div className="loading-wrapper">
            {propLoading && propData.length
                ? <div className="loading-wrapper__item"><Loading /></div>
                : null
            }
            <div className="table-responsive">
                <div className="wrap__desktop">
                    <table className={`table table-data ${propClassName}`}>
                        <Header
                            headerNames={propHeaderNames}
                            multiLevelHeaderNames={propMultiLevelHeaderNames}
                            columnData={propColumnData.header}
                        />
                        <tbody>
                            {(propData || []).map((item, i) => {
                                let className = item.className;
                                delete item.className;
                                return (
                                    <tr key={getKey(item.id || i)} className={className}>
                                        {Object.keys(item).map((key, j) => {
                                            const data = propColumnData.body[j] || {};
                                            let value;

                                            if(key === 'accountInfoMobile') {
                                                return;
                                            }

                                            if (typeof item[key] === 'object') {
                                                value = item[key];
                                            } else if (typeof item[key] === 'string'){
                                                value = Parser(item[key]);
                                            }

                                            if(value === undefined) {
                                                return;
                                            }

                                            return <td className={key} key={j} {...data}>{value}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    {!propData.length
                        ? propLoading
                            ? <Loading center={true} />
                            : <div className="text-center table-notfound-sign">{ staticNames.noData}</div>
                        : null
                    }
                </div>
                <div className="wrap__mobile account-list">
                    {(propData || []).map((item, i) => {
                        let className = "account-item";

                        return (
                            <div className={className} key={i}>
                                {Object.keys(item).map((key, j) => {
                                    const data = propColumnData.body[j] || {};
                                    let value;

                                    if (typeof item[key] === 'object') {
                                        value = item[key];
                                    } else if (typeof item[key] === 'string'){
                                        value = Parser(item[key]);
                                    }

                                    if(value === undefined) {
                                        return;
                                    }

                                    return <div className={key} key={j} {...data}>{value}</div>
                                })}
                            </div>
                        )})}
                </div>
            </div>
        </div>
    );
};

DataComponentTablePaymentAccounts.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    className: PropTypes.string,
    t: PropTypes.object
};

DataComponentTablePaymentAccounts.defaultProps = {
    data: [],
    loading: false,
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: { header: {}, body: {} },
    className: ''
};

export default withTranslation(DataComponentTablePaymentAccounts);
